module.exports = __webpack_public_path__ + "media/images/Off White 1_4 Circle-a8b1f88719a6869191c2aa58a2a48111.svg";